<template>
  <section>
    <section class="info-container">
      <section class="info-item-wrap">
        <p class="info-title m-t-16">车辆信息</p>
        <a-row class="m-t-18" type="flex">
          <a-col style="width: 200px">
            <a-row style="height: 100%" type="flex">
              <img
                class="car-image"
                :src="picServer + carInfo.carImage"
                alt=""
              />
            </a-row>
          </a-col>
          <a-col style="width: calc(100% - 200px)">
            <a-row>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">所属单位</a-col>
                  <a-col class="val">{{ carInfo.companyName }}</a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">车辆类型</a-col>
                  <a-col class="val">{{ carInfo.carTypeName }}</a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">车牌号</a-col>
                  <a-col class="val">{{ carInfo.carNumber }}</a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">录入日期</a-col>
                  <a-col class="val">{{ carInfo.createTime }}</a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">司机姓名</a-col>
                  <a-col class="val">{{ carInfo.carName }}</a-col>
                </a-row>
              </a-col>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">联系电话</a-col>
                  <a-col class="val">{{ carInfo.carBrand }}</a-col>
                </a-row>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-row class="info-item">
                  <a-col class="key">备注</a-col>
                  <a-col class="val">{{ carInfo.remarks }}</a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <!-- 资料文件 -->
        <section class="info-item-wrap m-t-10">
          <p class="info-title">资料文件</p>
          <section class="list-table-container">
            <a-table
              :bordered="false"
              size="small"
              class="m-t-18"
              :columns="fileData.columns"
              :data-source="fileData.data"
              :pagination="false"
            >
              <a-row v-if="list.fileUrl" slot="fileUrl" slot-scope="text, list">
                <preview-image :data="text" :size="44" />
              </a-row>
            </a-table>
          </section>
        </section>
      </section>

      <section class="info-item-wrap">
        <p class="info-title m-t-16">进场记录</p>

        <section class="search-container m-b-18 m-t-16">
          <a-form layout="inline" class="m-t-14">
            <a-form-item label="出入口名称">
              <a-select
                class="search-input"
                v-model="searchInfo.wayName"
                placeholder="请输入"
              >
                <a-select-option value="">全部</a-select-option>
                <a-select-option
                  v-for="(item, key) in carInletOutletList"
                  :key="key"
                  :value="item.doorwayName"
                  >{{ item.doorwayName }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="进出时间">
              <a-range-picker
                class="search-range-date"
                v-model="searchInfo.dateArea"
              />
            </a-form-item>

            <a-form-item>
              <a-button @click="search" class="m-r-8"
                ><a-icon type="search" />查询</a-button
              >
              <a-button @click="reset"><a-icon type="reload" />重置</a-button>
            </a-form-item>
          </a-form>
        </section>

        <section class="list-table-container">
          <a-table
            size="small"
            :columns="columns"
            :data-source="carInOutLog"
            :pagination="{ hideOnSinglePage: true }"
          >
            <a-row slot="inImage" slot-scope="text">
              <previewImage :data="text" :size="40" />
            </a-row>
            <a-row slot="outImage" slot-scope="text">
              <previewImage :data="text" :size="40" />
            </a-row>
          </a-table>
        </section>
      </section>
    </section>
  </section>
</template>

<script>
const columns = [
  { title: "序号", dataIndex: "key", align: "center", key: "key" },
  {
    title: "入口名称",
    dataIndex: "wayInName",
    align: "center",
    key: "wayInName",
  },
  { title: "进入时间", dataIndex: "inDate", align: "center", key: "inDate" },
  {
    title: "通行图像",
    dataIndex: "inImage",
    align: "center",
    key: "inImage",
    scopedSlots: { customRender: "inImage" },
  },
  {
    title: "出口名称",
    dataIndex: "wayOutName",
    align: "center",
    key: "wayOutName",
  },
  { title: "离开时间", dataIndex: "outDate", align: "center", key: "outDate" },
  {
    title: "通行图像",
    dataIndex: "outImage",
    align: "center",
    key: "outImage",
    scopedSlots: { customRender: "outImage" },
  },
  { title: "在场时长", dataIndex: "times", align: "center", key: "times" },
  { title: "进出次数", dataIndex: "key", align: "center", key: "key" },
];
const fileColumns = [
  {
    title: "序号",
    dataIndex: "key",
    align: "center",
    key: "key",
    width: "120px",
  },
  {
    title: "文件名称",
    dataIndex: "fileName",
    align: "center",
    key: "fileName",
  },
  {
    title: "附件",
    dataIndex: "fileUrl",
    align: "center",
    key: "fileUrl",
    scopedSlots: { customRender: "fileUrl" },
    width: "120px",
  },
];
// import moment from 'moment'
import previewImage from "@/components/previewImage";
export default {
  data() {
    return {
      carInfo: {},
      searchInfo: {
        dateArea: [],
      },
      //资料文件
      fileData: {
        columns: fileColumns,
        data: [],
      },
      columns,
      carInOutLog: [],
      carInletOutletList: [],
    };
  },
  components: { previewImage },
  computed: {
    cid() {
      return this.$route.query.id;
    },
    picServer() {
      return this.$store.state.picServer;
    },
  },
  created() {
    this.queryCarInfoDetails();
    this.queryCarInletOutletList();
  },
  methods: {
    queryCarInfoDetails() {
      let params = {
        id: this.cid,
        current: this.carInOutLog.pageNum,
        startDate: this.searchInfo.dateArea.length
          ? this.searchInfo.dateArea[0].format("YYYY-MM-DD")
          : "",
        endDate: this.searchInfo.dateArea.length
          ? this.searchInfo.dateArea[1].format("YYYY-MM-DD")
          : "",
        wayName: this.searchInfo.wayName,
      };
      this.$api.queryCarInfoDetails(params).then((res) => {
        if (res.code === 200) {
          this.carInfo = res.data || {};
          //资料文件
          this.fileData.data = res.data.carFileList || [];
          this.fileData.data.forEach((item, ind) => {
            item.key = ind + 1;
          });
          this.carInOutLog = (res.data && res.data.CarStatistical) || [];
          this.carInOutLog.forEach((item, ind) => {
            item.key = ind + 1;
          });
        }
      });
    },
    queryCarInletOutletList() {
      this.$api.queryCarInletOutletList({ size: 1000 }).then((res) => {
        if (res.code === 200) {
          this.carInletOutletList = (res.data && res.data.records) || [];
        }
      });
    },
    reset() {
      this.searchInfo.dateArea = [];
      this.queryCarInfoDetails();
    },
    search() {
      this.pageNum = 1;
      this.queryCarInfoDetails();
    },
  },
};
</script>

<style lang="scss" scoped>
.car-image {
  width: 80%;
  height: 80%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  max-height: 200px;
}
</style>